/* eslint-disable import/no-named-as-default */
import $ from 'jquery';
import base from '~base';
import { onEvent, getJSONData, isLG } from '../util/domutils'; // eslint-disable-line import/named
import { loadContent } from '../util/fetchutils';
import convertSizes from '../components/sizeConversions';
import stickyHeaderScrollHandle from '../components/stickyHeaderScroll';
import { EVENTS as FLYOUT_EVENTS } from '../components/flyoutUnderHeader';

const CONSTANTS = {
  ADD_NOTIFICATION_DISPLAY_TIME: 5000,
};

const CLASSES = {
  ATTRIBUTE_HAS_ERROR: 'product-detail__attribute--error',
};

const SELECTORS = {
  DETAILS: '.product-detail',
  VARIANT_DETAILS: '.product-detail__details-row',
  SET_DETAILS: '.set-item',
  ATTRIBUTES_CONTAINER: '.product-detail__attributes',
  ATTRIBUTE: '.product-detail__attribute',
  ATTRIBUTE_VALUE: '.product-detail__attribute__value',
  ATTRIBUTE_ERROR: '.product-detail__attribute__error',
  ATTRIBUTE_DROPDOWN: '.product-detail__attribute__dropdown',
  ADD_TO_BASKET_NOTIFICATION: '.product-detail__add-to-cart__notification',
  ADD_TO_WISHLIST_NOTIFICATION: '.product-detail__add-to-wishlist__notification',
  get SELECTED_ATTRIBUTE_VALUE() { return `${this.ATTRIBUTE_VALUE}--current`; },
};

const getDetailsContainer = (child) => {
  let productContainer = child.closest(SELECTORS.SET_DETAILS);

  if (!productContainer) {
    productContainer = child.closest(SELECTORS.VARIANT_DETAILS);
  }
  if (!productContainer) {
    productContainer = child.closest(SELECTORS.DETAILS);
  }

  return productContainer;
};

const handleAttributeChange = async (el) => {
  const container = getDetailsContainer(el);
  let isActiveATBMsg;
  let index;
  const $element = $(el);
  // eslint-disable-next-line jquery/no-closest
  const parent = $element.closest('.set-item');
  if (parent.length > 0) {
    // eslint-disable-next-line jquery/no-find
    const sameClassElements = $('body').find('.set-item');
    index = sameClassElements.index(parent);
  }

  if (index) {
    isActiveATBMsg = document.querySelectorAll('.add-to-bag-msg')
    && document.querySelectorAll('.add-to-bag-msg')[index].classList.contains('active');
  } else {
    isActiveATBMsg = document.querySelector('.add-to-bag-msg')
    && document.querySelector('.add-to-bag-msg').classList.contains('active');
  }
  document.dispatchEvent(new CustomEvent('product:beforeAttributeSelect'));

  // eslint-disable-next-line jquery/no-text
  const { content } = await loadContent(el, el.value, { pview: container.dataset.pview || 'pdp' });
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = content;
  let detailsOnly = '';
  if (tempContainer.querySelector(SELECTORS.VARIANT_DETAILS)) {
    detailsOnly = tempContainer.querySelector(SELECTORS.VARIANT_DETAILS).outerHTML;
    container.outerHTML = detailsOnly;
  }
  if (tempContainer.querySelector(SELECTORS.DETAILS) && detailsOnly === '') {
    detailsOnly = tempContainer.querySelector(SELECTORS.DETAILS).outerHTML;
    container.outerHTML = detailsOnly;
  }
  // eslint-disable-next-line no-undef
  if (typeof PayPalSDK !== 'undefined') {
    // eslint-disable-next-line no-undef
    PayPalSDK.Messages().render();
  }

  convertSizes();
  base.selectVariationPrompt();

  document.dispatchEvent(new CustomEvent('product:afterAttributeSelect'));
  const ispreorder = el.getAttribute('data-ispreorder');
  const preorderDisplayMessage = el.getAttribute('data-preordemessage');
  const deliveryAccordion = document.querySelector('.product-detail__accordion__product-details-delivery-returns');
  const preOrderMessage = document.querySelector('.pre-order__message');
  if (deliveryAccordion) {
    if (ispreorder === 'true') {
      preOrderMessage.innerHTML = preorderDisplayMessage;
      if (deliveryAccordion.classList.contains('d-none')) {
        deliveryAccordion.classList.remove('d-none');
      }
    } else if (!deliveryAccordion.classList.contains('d-none')) {
      deliveryAccordion.classList.add('d-none');
    }
  }
  // eslint-disable-next-line jquery/no-class
  if (!isLG()) {
    // eslint-disable-next-line jquery/no-class
    $('body,html').removeClass('overflow-text');
  }
  stickyHeaderScrollHandle();

  const isSizeEL = el && el.classList.contains('select-dropdown__list-item');
  if (isSizeEL || (isActiveATBMsg && el.dataset.attr === 'color')) {
    if (index >= 0) {
      // eslint-disable-next-line jquery/no-class
      $('.add-to-bag-msg').eq(index).addClass('active');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.add-to-bag-msg').addClass('active');
    }
  }

  // eslint-disable-next-line jquery/no-class
  const isNotify = el && el.querySelector('#notify-btn');
  if (isNotify) {
    // eslint-disable-next-line jquery/no-class
    if (index >= 0) {
      // eslint-disable-next-line jquery/no-class
      $('.add-to-bag-msg').eq(index).removeClass('active');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.add-to-bag-msg').removeClass('active');
    }
    if (index >= 0) {
      // eslint-disable-next-line jquery/no-class
      $('.continuity-flyout__pane').removeClass('show');
      // eslint-disable-next-line jquery/no-class
      $('.continuity-flyout__pane').eq(index).addClass('show');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.continuity-flyout__pane').addClass('show');
    }
  }
  $('.sizeguidelabel .close-icon, #sizeGuideAccordion, .continuity-flyout__close').on('click', () => {
    // eslint-disable-next-line jquery/no-class
    $('.select-dropdown__list,.select-dropdown__button').removeClass('active');
    // eslint-disable-next-line jquery/no-class
    if (!isLG()) {
      // eslint-disable-next-line jquery/no-class
      $('body,html').removeClass('overflow-text');
    }
  });
};

const handleErrorField = (data) => {
  data.forEach((attrObj) => {
    const attrContainer = document.querySelector(`${SELECTORS.ATTRIBUTE}--${attrObj.id}`);

    if (attrContainer) {
      const attrErrorContainer = attrContainer.querySelector(SELECTORS.ATTRIBUTE_ERROR);

      attrContainer.classList.add(CLASSES.ATTRIBUTE_HAS_ERROR);

      if (attrErrorContainer) {
        attrErrorContainer.innerHTML = attrObj.message;
      }
    }
  });
};

const handleErrorFieldForMultipleFields = (data, attributeContainer) => {
  data.forEach((attrObj) => {
    const attrContainer = attributeContainer.find(`${SELECTORS.ATTRIBUTE}--${attrObj.id}`);
    const attrErrorContainer = attrContainer.find(SELECTORS.ATTRIBUTE_ERROR);

    attrContainer.addClass(CLASSES.ATTRIBUTE_HAS_ERROR);

    if (attrErrorContainer) {
      attrErrorContainer.html(attrObj.message);
    }
  });
};

base.colorAttribute = () => {};

base.selectAttribute = () => {
  onEvent(document, 'click', SELECTORS.ATTRIBUTE_VALUE, async (e) => {
    e.preventDefault();

    const value = e.delegateTarget;

    if (value.dataset.action) {
      handleAttributeChange(value);
    }
  });

  onEvent(document, 'change', SELECTORS.ATTRIBUTE_DROPDOWN, async (e) => {
    const dropdown = e.delegateTarget;

    if (dropdown.value) {
      handleAttributeChange(dropdown);
    }
  });
};

base.appendAttributeValuesToAddRequest = () => {
  $(document).on('updateAddToCartFormData', (e, form) => {
    const selectedValues = document.querySelectorAll(SELECTORS.SELECTED_ATTRIBUTE_VALUE);
    const selectedValuesMap = Array.from(selectedValues).reduce((map, attrValue) => Object.assign(map, {
      [attrValue.dataset.attr]: attrValue.dataset.value,
    }), {});

    form.selectedValues = JSON.stringify(selectedValuesMap);
  });
};

base.handlePostCartAdd = () => {
  // eslint-disable-next-line no-unused-vars
  let lastClickedButton = null;
  $(document).on('updateAddToCartFormData', (e, data) => {
    if (!data.error) {
      lastClickedButton = e.target;
    }
  }).on('product:afterAddToCart', (e, data) => {
    const $button = $(lastClickedButton);

    // eslint-disable-next-line jquery/no-closest
    const parent = $button.closest('.set-item');
    if (parent.length > 0) {
      parent.find('.add-to-bag-msg').removeClass('active');
    } else {
      // eslint-disable-next-line jquery/no-class
      $('.add-to-bag-msg').removeClass('active');
    }

    if (data && !data.error) {
      // eslint-disable-next-line jquery/no-find, jquery/no-parents
      let notification = $button.parents(SELECTORS.DETAILS).find(SELECTORS.ADD_TO_BASKET_NOTIFICATION);
      if (notification.length > 1) {
        // eslint-disable-next-line jquery/no-find, jquery/no-parents
        notification = $button.parents(SELECTORS.SET_DETAILS).find(SELECTORS.ADD_TO_BASKET_NOTIFICATION);
      }
      if (notification) {
        notification.removeClass('d-none');

        setTimeout(() => {
          notification.addClass('d-none');
        }, CONSTANTS.ADD_NOTIFICATION_DISPLAY_TIME);
      }
    }

    if (data && data.attributeErrors) {
      // eslint-disable-next-line jquery/no-parents
      let attributeContainer = $button.parents(SELECTORS.DETAILS);
      if (attributeContainer.length > 1) {
        // eslint-disable-next-line jquery/no-parents
        attributeContainer = $button.parents(SELECTORS.SET_DETAILS);
        handleErrorFieldForMultipleFields(data.attributeErrors, attributeContainer);
      } else {
        handleErrorField(data.attributeErrors);
      }
    }
  });
};

base.handlePostWishlistAdd = () => {
  document.addEventListener('product:addedToWishlist', () => {
    const notification = document.querySelector(SELECTORS.ADD_TO_WISHLIST_NOTIFICATION);

    if (notification) {
      notification.classList.remove('d-none');

      setTimeout(() => {
        notification.classList.add('d-none');
      }, CONSTANTS.ADD_NOTIFICATION_DISPLAY_TIME);
    }
  });
};

base.styleFlyouts = () => {
  const toggleOpenedClass = (add) => {
    const container = document.querySelector(SELECTORS.DETAILS);

    if (container) {
      container.classList.toggle('flyout-open', !!add);
    }
  };

  document.addEventListener(FLYOUT_EVENTS.FLYOUT_OPEN, toggleOpenedClass.bind(null, true));
  document.addEventListener(FLYOUT_EVENTS.FLYOUT_CLOSE, toggleOpenedClass.bind(null, false));
};

base.selectVariationPrompt = () => {
  const attributeContainer = document.querySelector(SELECTORS.ATTRIBUTES_CONTAINER);

  if (attributeContainer && attributeContainer.dataset.attributeErrors) {
    const data = getJSONData(attributeContainer, 'attributeErrors');

    if (Object.keys(data).length > 0) {
      handleErrorField(data);
    }
  }
};

base.initSizeConversions = convertSizes;

export default base;
